export default {
  setSeats(state, payload) {
    state.seats = payload;
  },
};
